import { Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { formatarValorMonetario } from "../../../../../helpers/masks";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import GraficoMultiLine from "./GraficoMultiLine";
import PaperMUI from "../../../../../components/PaperMUI";

export default function CardFluxoCaixa() {

    function createData(
        dia: string,
        saldoInicial: number,
        recebimento: string,
        pagamentos: string,
        saldoFinal: number,
    ) {
        return { dia, saldoInicial, recebimento, pagamentos, saldoFinal };
    }

    const rows = [
        createData("04/07 qui", 190000, "(+) R$ 86.000,00", "(+) R$ 86.000,00", 256000),
        createData("05/07 qui", 256000, "(+) R$ 86.000,00", "(+) R$ 86.000,00", 200000),
        createData("06/07 qui", 200000, "-", "-", 200000),
        createData("07/07 qui", 200000, "-", "-", 200000),
        createData("08/07 qui", 200000, "(+) R$ 86.000,00", "(+) R$ 86.000,00", 100000),
        createData("09/07 qui", 100000, "(+) R$ 86.000,00", "(+) R$ 86.000,00", 130000),
        createData("10/07 qui", 130000, "(+) R$ 86.000,00", "(+) R$ 86.000,00", 200000),
    ];

    return (
        <PaperMUI featEmBreve>
            <Box p={2} mb={2} gap={2} display="flex" flexDirection='column'>
                <Box width="100%" display="flex" alignItems="center" justifyContent="space-between">
                    <Box>
                        <Typography variant='h6'>Fluxo de caixa</Typography>
                        <Typography variant='subtitle2'>Resumo para os próximos 7 dias</Typography>
                    </Box>
                    <Button variant="outlined" startIcon={<ArrowForwardIcon />}>
                        Análise avançada
                    </Button>
                </Box>

                <Box>
                    <GraficoMultiLine/>
                </Box>

                <TableContainer sx={{overflow: "auto"}}>
                    <Table size="small" aria-label="a dense table">
                        <TableHead sx={{ '& th': { fontWeight: 'bold', fontSize: 12 } }}>
                            <TableRow>
                                <TableCell >Dia</TableCell>
                                <TableCell align="right">Saldo inicial</TableCell>
                                <TableCell align="right">Recebimento</TableCell>
                                <TableCell align="right">Pagamentos</TableCell>
                                <TableCell align="right">Saldo final</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody
                            sx={{ '& td': { fontSize: 12 } }}
                        >
                            {rows.map((row) => (
                                <TableRow
                                    key={row.dia}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell>
                                        {row.dia}
                                    </TableCell>
                                    <TableCell align="right">{formatarValorMonetario(row.saldoInicial)}</TableCell>
                                    <TableCell align="right">{row.recebimento}</TableCell>
                                    <TableCell align="right">{row.pagamentos}</TableCell>
                                    <TableCell align="right">{formatarValorMonetario(row.saldoInicial)}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </PaperMUI>
    )
}